import React, { useState } from 'react';
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

function CourseContent({ seasonId, season, name, episodes }) {
    const [open, setOpen] = useState('A');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    const [openEp, setOpenEp] = useState('1');
    const toggleEp = (id) => {
        if (openEp === id) {
            setOpenEp();
        } else {
            setOpenEp(id);
        }
    };

    return (
        <div>
            <Accordion open={open} toggle={toggle}>
                <AccordionItem>
                    <AccordionHeader targetId={seasonId}><h5 style={{ marginBottom: "30px" }}>Season {season} : {name}</h5></AccordionHeader>
                    <AccordionBody accordionId={seasonId}>
                        <div>
                            {episodes.map(item => {
                                return (
                                    <Accordion open={openEp} toggle={toggleEp}>
                                        <AccordionItem>
                                            <AccordionHeader targetId={item.id}><strong>{item.name}</strong></AccordionHeader>
                                            <AccordionBody accordionId={item.id}>{item.desc}</AccordionBody>
                                        </AccordionItem>
                                    </Accordion>
                                )
                            })}
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </div>
    );
}

export default CourseContent;